import React from 'react';
import { Hero } from './components/Hero';
import { PainRelief } from './components/PainRelief';
import { WhatsInside } from './components/WhatsInside';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-cream selection:bg-rose selection:text-heading" data-id="element-0">
      <Hero data-id="element-1" />
      <PainRelief data-id="element-2" />
      <WhatsInside data-id="element-3" />
      <FinalCTA data-id="element-4" />
      <Footer data-id="element-5" />
    </main>;
}